'use client';

import React from 'react';
import { PulseToggle } from 'src/components/PulseUI';
import { faBell, faBellSlash } from '@fortawesome/pro-solid-svg-icons';

interface NotificationToggleProps {
  value?: boolean;
  onChange?: (enabled: boolean) => void;
}

const NotificationToggle: React.FC<NotificationToggleProps> = ({
  value = true,
  onChange,
}) => {
  const handleChange = (newValue: 'enabled' | 'disabled') => {
    onChange?.(newValue === 'enabled');
  };

  const options = [
    {
      value: 'enabled' as const,
      label: 'Enabled',
      icon: faBell,
    },
    {
      value: 'disabled' as const,
      label: 'Disabled',
      icon: faBellSlash,
    },
  ];

  return (
    <PulseToggle
      value={value ? 'enabled' : 'disabled'}
      options={options}
      onChange={handleChange}
      size="sm"
    />
  );
};

export default NotificationToggle;
